import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const TissueInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Tissue Section"
    sectionKey="Tissue"
    backRoute="/sections/tissue"
  />
);

export default TissueInternalTransfer;
